/**
 * tiptap extensions for the CRM rich text editor that plain `configure()` cannot
 * express. React-free on purpose, so the round trip they guard (HTML in -> HTML out)
 * can be exercised without mounting the editor component.
 */
import Link from "@tiptap/extension-link";

/** The class a link gets when the markup does not name one of its own. */
export const LINK_DEFAULT_CLASS = "text-primary underline";

/**
 * Link whose default class a hand-written class can actually replace.
 *
 * tiptap renders a mark through `mergeAttributes`, and that helper CONCATENATES
 * `class` instead of overwriting it. While the default class lived in the
 * extension's `HTMLAttributes` option, a class typed in the HTML source view was
 * glued behind it: `class="text-secondary underline"` came back as
 * `class="text-primary underline text-secondary"`. Holding the default on the
 * `class` attribute instead leaves one single source for it, so a link that names
 * no class still renders `text-primary underline`, and a link that names one keeps
 * exactly what was written.
 */
export const StyledLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: { default: LINK_DEFAULT_CLASS },
    };
  },
});
